import React , {useState,useEffect} from 'react'
import { Button, Stack } from '@mui/material'
import PageHeading from '../../Components/PageHeading'
import CustomInfoTooltip from '../../Components/CustomInfoTooltip'
import { AppColors } from '../../Utils/helper/AppColors'
import { AddIcon } from '../../Components/Icons/Icons'
import DashBoardCards from './Components/DashBoardCards'
import DashboardGraphs from './Components/DashboardGraphs'
import ExitInterviewTable from './Components/ExitInterviewTable'
import { useSelector } from 'react-redux'
import CultService from '../../Services/CultService'
import toast from 'react-hot-toast'
import { HelperTexts } from '../../Utils/helper/HelperTexts'
import DashBoardFilters from './Components/DashBoardFilters'
import dayjs from 'dayjs'
import DashboardEmptyView from '../Dashboard/Components/DashboardEmptyView'
import { useNavigate } from 'react-router-dom'
import { PATH_NAME } from '../../Routes/Pathname'
import PageLoader from '../../Components/PageLoader'

const ExitInterviewDashboard = () => {

   // State buckets
  const [summaryData, setSummaryData] = useState(null);
  const [trendData, setTrendData] = useState([]);
  const [reasonsData, setReasonsData] = useState([]);
  const [recentExits, setRecentExits] = useState([]);
  const [recentPagination, setRecentPagination] = useState(null);
  const [exitInterviewCampaigns, setExitInterviewCampaigns] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ count: 0, rowsPerPage: 10, page: 1 });
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
  dateRange : 'LAST_90_DAYS',
	from: dayjs().subtract(2, 'month').format('YYYY-MM-DD'),
	to: dayjs().format('YYYY-MM-DD'),
	departments: [],
  campaignIds: [],
	sentimentBucket: 'ALL',
	groupBy: 'monthly',
  });

  console.log('filters in dashboard', filters)
  
  
  const company = useSelector((state) => state?.app?.company);

// Return data instead of setting state
const fetchExitSummary = async () => {
  const res = await CultService.getExitInterviewSummary({
    params: { companyId: company?._id, from: filters.from, to: filters.to, departments: filters.departments, sentimentBucket: filters.sentimentBucket , campaignIds: filters.campaignIds  },
  });
  if (res?.data?.status) return res.data.data;
  throw new Error('summary failed');
};

const fetchExitSentimentTrend = async () => {
  const res = await CultService.getExitInterviewSentimentTrend({
    params: { companyId: company?._id, from: filters.from, to: filters.to, groupBy: filters.groupBy, departments: filters.departments, sentimentBucket: filters.sentimentBucket , campaignIds: filters.campaignIds  },
  });
  if (res?.data?.status) return res.data.data ?? [];
  throw new Error('trend failed');
};

const fetchExitReasons = async () => {
  const res = await CultService.getExitInterviewReasons({
    params: { companyId: company?._id, from: filters.from, to: filters.to, sentimentBucket: filters.sentimentBucket ,departments: filters.departments , campaignIds: filters.campaignIds },
  });
  if (res?.data?.status) return res.data.data ?? [];
  throw new Error('reasons failed');
};

const fetchRecentExitInterviews = async (page,rowsPerPage) => {
  const res = await CultService.getExitInterviewRecent({
    params: { companyId: company?._id, from: filters.from, to: filters.to, sentimentBucket: filters.sentimentBucket , departments: filters.departments , campaignIds: filters.campaignIds , page: page || 1, limit: rowsPerPage || 10 },
  });
  if (res?.data?.status) return res?.data?.data || [];
  throw new Error('recent failed');
};

const getList = async (page, rowsPerPage) => {
  try {
    setLoading(true);
    let data = await fetchRecentExitInterviews(page, rowsPerPage);
    setRecentExits(data?.recordings);
    setPagination({
      count: data?.totalRecords || 0,
      rowsPerPage: rowsPerPage || 10,
      page: data?.currentPage || 1,
			totalPages: data?.totalPages || 1,
    });

  } catch (err) {
    toast.error(HelperTexts?.SOMETHING_WENT_WRONG);
    console.log('getList error:', err);
  }
  finally {
    setLoading(false);
  }
};

  const getExitInterviewCampaigns = async () => {
    try {
      const res = await CultService.getCampaignBasicDetails({
        params: { companyId : company?._id, status: [] ,  campaignType: 'EXIT_INTERVIEW' ,  },
      })
          if(res?.data?.status === 200){
            console.log('campaigns data', res)
            setExitInterviewCampaigns(res?.data?.data || [])
          }
    } catch (err) {
      toast.error(HelperTexts?.SOMETHING_WENT_WRONG)
      console.log('getExitInterviewCampaigns error:', err)
    }
  }

    const getcampaignType = async () => {
      let res = await CultService.getFilterValues({ params: { companyId: company._id } });
      // console.log('res', res);
      setDepartments(res?.data?.departments || []);
    };

 // Use Promise.all
useEffect(() => {
  if (!company?._id) return;

  const runAll = async () => {
    try {
      setLoading(true);
      const [summary, trend, reasons, recent] = await Promise.all([
        fetchExitSummary(),
        fetchExitSentimentTrend(),
        fetchExitReasons(),
        fetchRecentExitInterviews(1,5), // Default to page 1 and 5 rows per page
      ]);

      setSummaryData(summary);
      setTrendData(trend);
      setReasonsData(reasons);
      setRecentExits(recent?.recordings || []);
      setPagination({
        count: recent?.totalRecords || 0,
        rowsPerPage: 10,
        page: recent?.currentPage || 1,
        totalPages: recent?.totalPages || 1,
      });
    } catch (err) {
      toast.error(HelperTexts?.SOMETHING_WENT_WRONG);
      console.log('Parallel fetch error:', err);
    }
    finally {
      setLoading(false);
    }
  };

  runAll();
}, [company?._id, JSON.stringify(filters)]);

  useEffect(() => {
    if( !company?._id ) return;
    getcampaignType();
    getExitInterviewCampaigns()
  }, [company?._id]);

  return (
   <Stack sx={{ padding: 2 }}>
			<PageHeading
				title={`Exit Dashboard`}
				titleSx={{ fontSize: 24, fontWeight: 600, lineHeight: '130%', fontFamily: 'Poppins, Arial, sans-serif' }}
				subTitle="View and manage all your exit interview campaigns in one place."
				subTitleSx={{ fontSize: 1, fontWeight: 400, color: AppColors.LIGHT_GRAY, lineHeight: '150%' }}
				renderRight={
					<Stack direction="row" alignItems="center" gap={2}>
						{exitInterviewCampaigns?.length !== 0 && (   // UPDATESEVEN
							<>
								<Button
									onClick={() =>  navigate(PATH_NAME.CAMPAIGN_CREATE, { state: { isExitInterviewCampaign : true } })}
									startIcon={<AddIcon color={AppColors.WHITE} />}
									variant="contained"
									color="info"
								>
									Schedule New Exit
								</Button>
								{/* <CustomInfoTooltip title="Filter by campaign" placement={'bottom'}>
									<Button
										// onClick={() => navigate(PATH_NAME.CAMPAIGN_EDIT, { state: { fromDashboard: true } })}
										// startIcon={<AddIcon color={AppColors.WHITE} />}
										variant="contained"
										color="info"
									>
										Filter
									</Button>
								</CustomInfoTooltip> */}
							</>
						)}
					</Stack>
				}
			/>

        { exitInterviewCampaigns?.length === 0 ?  
   <DashboardEmptyView isExitInterview={true} /> :
  
	  <Stack gap={2} mt={3}>
      {/* All Filters - 1 */}
      <DashBoardFilters filters={filters} setFilters={setFilters} exitInterviewCampaigns={exitInterviewCampaigns} departments={departments} />
       
      {/* Cards - 2  */}
      <DashBoardCards summaryData={summaryData} />

      {/* Graphs - 3 */}
      <DashboardGraphs trendData={trendData} reasonsData={reasonsData} />

      {/* Table - 4 */}

      <ExitInterviewTable list={recentExits} getList={getList} pagination={pagination} />
      </Stack>


        }
        {loading && <PageLoader />}
    </Stack>
  )
}

export default ExitInterviewDashboard